import { useState, useEffect } from 'react';
import { ENDPOINTS, ADMIN_ENDPOINTS, adminFetch } from '../config';
import AdminSectionEditor from './AdminSectionEditor';
import './Admin.css';

export default function AdminAbout() {
  const [biography, setBiography] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch(ENDPOINTS.about)
      .then((r) => r.json())
      .then((arr) => {
        if (arr && arr[0]) setBiography(arr[0].biography || '');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setSaving(true);
    try {
      const res = await adminFetch(ADMIN_ENDPOINTS.saveAbout, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ biography }),
      });
      const data = await res.json();
      if (data.error) setMessage(data.error);
      else setMessage('Saved successfully.');
    } catch {
      setMessage('Failed to save.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Loading…</p>;

  return (
    <>
      <h1>About</h1>
      <form onSubmit={handleSubmit}>
        {message && <p style={{ color: message.includes('success') ? '#3fb950' : 'var(--admin-danger)' }}>{message}</p>}
        <div className="form-group">
          <label>Biography</label>
          <AdminSectionEditor
            value={biography}
            onChange={setBiography}
            placeholder="Write biography…"
          />
        </div>
        <button type="submit" className="btn" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
      </form>
    </>
  );
}
